import { ErrorMessage, Field, Form, Formik } from 'formik'
import { v4 as uuidv4 } from 'uuid';
import WrapperAccordion from '../general/WrapperAccordion'
import FieldWrapper from '../forms/FieldWrapper'
import Translation from '../Translation/cont/Translation'
import { reorderListItems } from '../../functions/lists'
import { List, Map } from 'immutable'
import AddItemToList from './fields/List/AddItemToList'
import { EDIT_NEWSLETTER_CAP } from '../../constants/caps'
import SortableList from './fields/List/SortableList'
import getNewsletterStylesData from '../PageNewsletterTemplate/functions/getNewsletterStylesData'
import ColorPicker from './fields/ColorPicker'
import getTranslationStringById from '../Translation/func/getTranslationStringById';
import ButtonPreviewCancelSubmit from '../general/ButtonPreviewCancelSubmit';
import RadioButtonGroup from './fields/RadioButtonGroup';
import OverlayForm from '../overlay/presentational/OverlayForm';
import FarreyFrac from '../../classes/farreyFrac';

const FormNewsletterSettings =  ({
    itemData,
    themeData,
    translationStrings,
    currentLang,
    translationDebug,
    setSettingsOverlay,
    onSwitchToPreview,
    onResetSettings,
    onUpdateSettings
}) => {

    const newsletterStructureOptions = [
        {
            itemType: 'week',
            transId: 'print_newsletter_structure_week',
            headlineFront: '',
            headlineClient: getTranslationStringById('week_newsletter_content_selection', translationStrings, currentLang, 'Wochenauswahl', translationDebug)
        },
       {
            itemType: 'content',
            transId: 'print_newsletter_structure_content',
            headlineFront: '',
            headlineClient: getTranslationStringById('print_newsletter_content_selection', translationStrings, currentLang, translationDebug)
        },
        {
            itemType: 'highlights',
            transId: 'print_newsletter_structure_highlights',
            headlineFront: '',
            headlineClient: getTranslationStringById('print_newsletter_highlight_selection', translationStrings, currentLang, translationDebug)
        },
       {
            itemType: 'movies',
            transId: 'print_newsletter_structure_movies',
            headlineFront:  getTranslationStringById('print_newsletter_preview_program', translationStrings, currentLang, translationDebug), // pflicht
            headlineClient: getTranslationStringById('print_newsletter_selection_of_new_movies', translationStrings, currentLang, translationDebug)
        },
       {
            itemType: 'movie_performances',
            transId: 'print_newsletter_structure_movie_performances',
            headlineFront:  getTranslationStringById('print_newsletter_preview_program_performances', translationStrings, currentLang, translationDebug), // pflicht
            headlineClient: getTranslationStringById('print_newsletter_selection_movie_performances', translationStrings, currentLang, translationDebug)
        },        
        {
            itemType: 'social_media',
            transId: 'print_newsletter_structure_social_media',
            headlineFront: '',
            headlineClient: getTranslationStringById('print_newsletter_structure_social_media', translationStrings, currentLang, translationDebug)
        },
        {   
            itemType: 'text',
            transId: 'print_newsletter_structure_text',
            headlineFront: '',
            headlineClient: getTranslationStringById('print_newsletter_structure_text', translationStrings, currentLang, translationDebug)
        },
        {
            itemType: 'image',
            transId: 'print_newsletter_structure_image',
            headlineFront: '',
            headlineClient: getTranslationStringById('print_newsletter_structure_image', translationStrings, currentLang, translationDebug)
        }
    ]

    const getOrderAttributeByIndex = (index, orderSize, order, items) => {
        if(-1 === index) {
            return [0,1]
        } else if(orderSize === index){
            return [1,0]
        } else {
            return items[order.get(index)].order
        }
    }

    const getFractalOrder = (index, order, items) => {
        const orderSize = order.count()
        const orderPrev = getOrderAttributeByIndex(index - 1, orderSize, order, items)
        const orderNext = getOrderAttributeByIndex(index + 1, orderSize, order, items)
        const farreyFrac = new FarreyFrac(orderPrev, orderNext)

        return farreyFrac.order()
    }

    const onAddListItem = (newStructure, structure, setFieldValue) => {
        const key = uuidv4()
        const order = List(structure.order)
        const items = Map(structure.items)
        const newOrder = order.push(key)
        const fractalOrder = getFractalOrder(newOrder.size - 1, newOrder, structure.items)

        const newItem = {
            pk: key,
            order: fractalOrder,
            ... newStructure
        }

        setFieldValue('structure', {
            order: newOrder.toJS(),
            items: items.set(key, newItem).toJS()
        })
    }

    const onDeleteListItem = (index, structure, setFieldValue) => {
        const key = structure.order[index]
        const order = List(structure.order)
        const items = Map(structure.items)

        setFieldValue('structure', {
            order: order.delete(index).toJS(),
            items: items.delete(key).toJS()
        })
    }
    

    const onReorderListItem = (oldIndex, newIndex, structure, setFieldValue) => {
        const newOrder = reorderListItems(new List(structure.order), oldIndex, newIndex)
        const fractalOrder = getFractalOrder(newIndex, newOrder, structure.items)

        setFieldValue('structure.order', newOrder.toJS())
        setFieldValue('structure.items.' + newOrder.get(newIndex) + '.order', fractalOrder)
    }

    const onUpdateListItem = (id, structureItems, values, setFieldValue) => {
        const items = Map(structureItems)
        const newItems = items.set(id, values)

        setFieldValue('structure.items', newItems.toJS())
    }

    const onResetStyle = (styleKey, themeData, setFieldValue) => {
        const themeDefaults = getNewsletterStylesData(false, themeData)

        setFieldValue(`style.${styleKey}`, themeDefaults[styleKey])
    }

    const setStyleOverride = (newStyle, themeData) => {
        const overideStyle = {}
        const themeDefaults = getNewsletterStylesData(false, themeData)

        Object.keys(newStyle).map(key => {
            overideStyle[key] = newStyle[key] === themeDefaults[key] ? null : newStyle[key] 
        })

        return overideStyle
    }

    const getStructureWithTransIds = structure => {
        structure.order.map(id => {
            structure.items[id].transId = 'print_newsletter_structure_' + structure.items[id].itemType
        })

        return structure
    }

    const campaignStyle = itemData.style ? itemData.style : false

    const initialValues = {
        name: itemData.hasOwnProperty('name') && itemData.name ? itemData.name  : '',
        description: itemData.hasOwnProperty('description') && itemData.description ? itemData.description  : '',
        structure: itemData.hasOwnProperty('structure') ? getStructureWithTransIds(itemData.structure) : {},
        style: getNewsletterStylesData(campaignStyle, themeData)
    }

    return (
        <Formik 
            initialValues={initialValues}
            onSubmit={(values, actions) => {
                onUpdateSettings({
                    ... values,
                    style: setStyleOverride(values.style, themeData),
                    order: itemData.order
                })

                actions.resetForm({
                    values: values
                })
            }}
        >
            {({ values, errors, dirty, isSubmitting, setFieldValue, handleReset }) => (
                <Form>
                    <WrapperAccordion
                        className="single-section"
                        selectionActiveClass="accordion-item-open"
                    >
                        <fieldset>
                            <div className="form-content newsletter-settings">
                                <div className="left-sections">
                                    <FieldWrapper label={<Translation id="newsletter_campaign_name"/>} id="newsletter-title" classes="field-text">
                                        <Field type="text" name="name" id="cnewsletter-title" className="text-regular input-text-box" />
                                        <ErrorMessage name="name" component="div" /> 
                                    </FieldWrapper>

                                    <FieldWrapper label={<Translation id="newsletter_campaign_description"/>} id="newsletter-description" classes="field-text">
                                        <Field type="text" name="description" id="newsletter-description" className="text-regular input-text-box" />                                        
                                        <ErrorMessage name="description" component="div" /> 
                                    </FieldWrapper>

                                    <SortableList
                                        className='newsletter-structure-list field-text'
                                        label={<Translation id="newsletter_campaign_structure" />}
                                        order={values.structure.order}
                                        items={values.structure.items}
                                        itemOptions={[
                                            {
                                                type: 'button',
                                                action: 'edit',
                                                onClick: index => {
                                                    const itemId = values.structure.order[index]
                                                    const item = values.structure.items[itemId]
                                                    const inputOptions = []

                                                    if(!['week', 'highlights', 'text', 'image'].includes(item.itemType)) {
                                                        inputOptions.push({
                                                            id: 'headlineFront',
                                                            type: 'text',
                                                            transId: 'newsletter_headline_front'
                                                        })
                                                    }

                                                    inputOptions.push({
                                                        id: 'headlineClient',
                                                        type: 'text',
                                                        transId: 'newsletter_headline_client'
                                                    })
                                                    
                                                    setSettingsOverlay(
                                                        <OverlayForm
                                                            initValues={item}
                                                            inputOptions={inputOptions}
                                                            editDisabled={false}
                                                            onClose={() => setSettingsOverlay(false)}
                                                            onSubmitValues={(newValues) => onUpdateListItem(itemId, values.structure.items, newValues, setFieldValue)}
                                                        />
                                                    )
                                                }
                                            },
                                            {
                                                type: 'button',
                                                action: 'move'
                                            },
                                            {
                                                type: 'button',
                                                action: 'delete',
                                                onClick: (index) => onDeleteListItem(index, values.structure, setFieldValue)
                                            },
                                            {
                                                type: 'translation',
                                                key: 'transId'
                                            },
                                            {
                                                type: 'text',
                                                key: 'headlineClient'
                                            }
                                        ]}
                                        onReorderItem = {
                                            (oldIndex, newIndex) => onReorderListItem(oldIndex, newIndex, values.structure, setFieldValue)
                                        }
                                    />

                                    <div className="newsletter-structure-add-item">
                                        <AddItemToList
                                            options={newsletterStructureOptions}
                                            cap={EDIT_NEWSLETTER_CAP}
                                            classNameHeading='button'
                                            transIdAdd='section_add_item'
                                            transIdSubmit='section_add_item'
                                            onAddItem={(newStructure) => onAddListItem(newStructure, values.structure, setFieldValue)}
                                        />
                                    </div>

                                    <div className="newsletter-styles-colors">
                                        <h3 className="section-heading"><Translation id="newsletter_settings_colors"/></h3>

                                        <div className="newslette-styles-grid">
                                            {Object.keys(values.style)
                                                .filter(key => !['fskColors', 'chosenFont', 'themeColors', 'buttonRadius', 'posterRadius', 'buttonGradient'].includes(key))
                                                .map((styleKey, index)  => (
                                                    <ColorPicker  
                                                        key={index}
                                                        name={<Translation id={'style_' + styleKey}/>}
                                                        value={values.style[styleKey]}
                                                        onSetValue={
                                                            (color, even) => {
                                                                if(color && color.hasOwnProperty('hex')) {
                                                                    setFieldValue(`style.${styleKey}`, color.hex)
                                                                }
                                                            }
                                                        }
                                                        onReset={() => onResetStyle(styleKey, themeData, setFieldValue)}
                                                    />                                             
                                                ))
                                            }
                                        </div>

                                        <RadioButtonGroup
                                            label={<Translation id="newsletter_settings_fsk_colors" />}
                                            className='newsletter-fsk-colors field-text'
                                            fieldsetChildren={
                                                <div className="button button-reset cursor-pointer color-picker-reset" onClick={() => onResetStyle('fskColors', themeData, setFieldValue)}>Reset</div>
                                            }
                                        >
                                            {['Dark','Light'].map((fskColor, index) => (
                                                <label className="control control-radio" htmlFor={fskColor} key={index}>
                                                    {fskColor}
                                                    <input
                                                        id={fskColor} 
                                                        className="radio-button"
                                                        type="radio" 
                                                        value={fskColor}
                                                        onChange={() => setFieldValue('style.fskColors', fskColor)}
                                                        checked={values.style.fskColors === fskColor}
                                                    />
                                                    <div className="control_indicator"></div>
                                                </label>
                                            ))}
                                        </RadioButtonGroup>

                                    </div>
                                </div>
                            </div>

                            <ButtonPreviewCancelSubmit
                                transIdPreview="button_preview"
                                transIdCancel="cancel_button"
                                transIdSubmit="button_submit_settings"
                                disablePreview={dirty}
                                disabledCancel={isSubmitting}
                                disabledSubmit={!dirty || isSubmitting}
                                onPreview={() => !dirty && onSwitchToPreview()}
                                onCancel={() => onResetSettings()}
                            />
                        </fieldset>
                        
                    </WrapperAccordion>

                </Form>
            )}
        </Formik>
    )
}

export default FormNewsletterSettings